module.exports = __webpack_public_path__ + "static/media/FootLocker-DAngeloRussell.adff83c5.jpg";